import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "button", "label", "addSt"];

  connect() {
    if (this.hasAddStTarget) {
      this.addStTarget.click();
    }
  }

  selectEnterprise() {
    const id = event.target.id;
    this.buttonTarget.disabled = false;
    this.labelTargets.forEach((label) => label.classList.remove("text-bold"));
    event.currentTarget.nextElementSibling.classList.add("text-bold");
    const link = this.linkTarget
      .getAttribute("href")
      .replace(
        /(\/mode_operatoires\/)(.*)(\/[edit|risk_analysis])/,
        `$1${id}$3`
      );
    this.linkTarget.setAttribute("href", link);
  }
}
